import { PublicClientApplication } from "@azure/msal-browser";

export const SIGNUP_PROFILE_KEY = "signupProfile";

export async function startSignup(loginHint?: string) {
  const clientId = process.env.REACT_APP_MSAL_CONFIG_CLIENT_ID?.trim();
  if (!clientId)
    throw new Error("Missing REACT_APP_MSAL_CONFIG_CLIENT_ID configuration");
  const tenantName = process.env.REACT_APP_B2C_POLICIES_TENANT_NAME;
  if (!tenantName) throw new Error("Missing B2C tenant name");
  const policy = process.env.REACT_APP_B2C_SIGN_UP?.trim();
  if (!policy) throw new Error("Missing REACT_APP_B2C_SIGN_UP configuration");
  const authority = `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/${policy}`;
  const signupTenant = { clientId, instance: authority };
  const instance = new PublicClientApplication({
    auth: {
      clientId,
      authority,
      knownAuthorities: [`${tenantName}.b2clogin.com`],
      redirectUri: process.env.REACT_APP_REDIRECT_URL || "/",
      navigateToLoginRequestUrl: false,
    },
    cache: { cacheLocation: "localStorage" },
  });
  await instance.initialize();
  localStorage.setItem("authTenant", JSON.stringify(signupTenant));
  sessionStorage.setItem("signupInProgress", "true");
  try {
    await instance.loginRedirect({
      scopes: ["openid", "profile"],
      loginHint: loginHint || undefined,
      extraQueryParameters: {
        ...(loginHint ? { email: loginHint } : {}),
        prompt: "login",
      },
    });
  } catch (error) {
    sessionStorage.removeItem("signupInProgress");
    localStorage.removeItem("authTenant");
    throw error;
  }
}

export function rememberSignupProfile() {
  sessionStorage.setItem(SIGNUP_PROFILE_KEY, "true");
}
